import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { putAPI } from "../backend/commons";
import AlertManager from "../shared/Alert/Alert";

export const updateLandedCostSkuExclusionHistory = async (payload = []) => {
  const tokenInfo = await getJWTToken();
  const apiUrl = `${localDatabaseUrls.baseURL}${localDatabaseUrls.serviceURL.landedCostSkuExclusionHistoryUpdate}`;
  const body = typeof payload === "string" ? payload : JSON.stringify(payload);
  const response = await putAPI(apiUrl, tokenInfo, body);

  if (!response) {
    AlertManager.error("Unable to update SKU exclusion history.");
    return null;
  }

  if (response.ok) {
    AlertManager.success("SKU exclusion history updated successfully.", { contactSupport: false });
    return response;
  }

  const errorData = await response.json().catch(() => ({}));
  AlertManager.error(errorData?.message || "Failed to update SKU exclusion history.");
  return null;
};

export default updateLandedCostSkuExclusionHistory;
